// pages/akses/JenisPengguna.jsx

import React, { useState, useEffect } from "react";
import RoleSelector from "../../../components/Akses/RoleSelector";
import AccessTable from "../../../components/Akses/AccessTable";
import { roles as defaultRoles } from "../../../mock/roles";
import { accessMatrix as initialAccessMatrix } from "../../../mock/accessMatrix";

const JenisPengguna = () => {
  const [selectedRole, setSelectedRole] = useState("");
  const [tempPermissions, setTempPermissions] = useState({});

  const [roleList] = useState(() => {
    const saved = localStorage.getItem("roles");
    return saved ? JSON.parse(saved) : defaultRoles;
  });

  const [accessMatrix, setAccessMatrix] = useState(() => {
    const saved = localStorage.getItem("accessMatrix");
    return saved ? JSON.parse(saved) : initialAccessMatrix;
  });

  // Load permissions dari role yang dipilih
  useEffect(() => {
    if (selectedRole) {
      const rolePermissions = accessMatrix[selectedRole]?.permissions || {};
      setTempPermissions(rolePermissions);
    }
  }, [selectedRole, accessMatrix]);

  // Update akses ke accessMatrix + localStorage
  const handleUpdateAccess = () => {
    const fixedMatrix = { ...accessMatrix };
    if (!fixedMatrix[selectedRole]) {
      fixedMatrix[selectedRole] = { permissions: {} };
    }
    fixedMatrix[selectedRole].permissions = tempPermissions;

    setAccessMatrix(fixedMatrix);
    localStorage.setItem("accessMatrix", JSON.stringify(fixedMatrix));
    alert(`✅ Akses berhasil diperbarui untuk role: ${selectedRole}`);
  };

  // Checkbox change sementara
  const handleCheckboxChange = (modul, action, checked) => {
    setTempPermissions((prev) => {
      const current = prev[modul] || [];

      let updated = [];
      if (action === "all") {
        updated = checked ? ["lihat", "tambah", "edit", "hapus"] : [];
      } else {
        updated = checked
          ? [...new Set([...current, action])]
          : current.filter((a) => a !== action);
      }

      return {
        ...prev,
        [modul]: updated,
      };
    });
  };

  const visibleRoles = roleList.filter((r) => r !== "Super Admin");

  return (
    <div className="p-6 pl-64">
      <div className="flex items-center justify-between mb-6">
        <RoleSelector
          roles={visibleRoles}
          selectedRole={selectedRole}
          onChange={setSelectedRole}
          // onAddRole={() => {}} // nonaktif
          // onDeleteRole={() => {}} // nonaktif
        />
        {selectedRole && (
          <button
            onClick={handleUpdateAccess}
            className="px-5 py-2 text-white transition bg-green-600 rounded-lg hover:bg-green-700"
          >
            🔄 Update Akses
          </button>
        )}
      </div>

      {selectedRole && (
        <AccessTable
          role={selectedRole}
          access={tempPermissions}
          onChange={handleCheckboxChange}
        />
      )}
    </div>
  );
};

export default JenisPengguna;
